var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcExitToApp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "nchh5unnxa",
    d: "M8.408 12.992l1.175 1.175L13.75 10 9.583 5.833 8.408 7.008l2.15 2.159H2.5v1.666h8.058l-2.15 2.159zM15.833 2.5H4.167c-.925 0-1.667.75-1.667 1.667V7.5h1.667V4.167h11.666v11.666H4.167V12.5H2.5v3.333c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.167c0-.917-.75-1.667-1.667-1.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kej7r7ibdb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#nchh5unnxa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BEC4CA",
    mask: "url(#kej7r7ibdb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H41.667V41.667H0z",
    transform: "translate(-10.833 -10.833)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcExitToApp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-exit-to-app.d399c90e.svg";
export { ForwardRef as ReactComponent };